module.exports = __webpack_public_path__ + "static/media/Knowledge.4e0d9ffc.svg";